import MuiListItemIcon from "@mui/material/ListItemIcon";

export default function ListItemIcon(props) {
  return <MuiListItemIcon {...props} />;
}
